import React, { useEffect, useState, useRef } from "react";
import heic2any from "heic2any";
import useToaster from "../../customHook/useToaster";
import { Box, LinearProgress, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E94D51",
    },
  },
});

const HeicViewer = ({ selectedDoc }) => {
  const { showToast } = useToaster();
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    if (!selectedDoc) return;
    setLoading(true);
    const timer = setInterval(() => {
      setProgress((prevProgress) => Math.min(prevProgress + 1, 99));
    }, 150);

    fetch(selectedDoc?.document_path)
      .then((res) => res.blob())
      .then((blob) =>
        heic2any({
          blob,
          toType: "image/png",
          quality: 0.72,
        })
      )
      .then((conversionResult) => {
        clearInterval(timer);
        setProgress(100);
        const url = URL.createObjectURL(conversionResult);
        setTimeout(() => {
          if (imageRef.current) {
            imageRef.current.src = url;
          }
          setLoading(false);
        }, 150);
      })
      .catch((e) => {
        showToast(e.message, "error", true);
        setLoading(false);
        clearInterval(timer);
      });

    return () => {
      clearInterval(timer);
    };
  }, [selectedDoc]);

  return (
    <div>
      {loading && (
        <ThemeProvider theme={theme}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: "20%",
            }}
          >
            <Box sx={{ width: "95%", height: "20px", mr: 1 }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{ height: "20px", borderRadius: "10px" }}
              />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography
                fontSize="3rem"
                variant="body2"
                color="primary"
                sx={{ mixBlend: "difference", mt: "1rem" }}
              >
                Loading...{`${Math.round(progress)}%`}
              </Typography>
            </Box>
          </Box>
        </ThemeProvider>
      )}
      <img
        ref={imageRef}
        alt="Converted HEIC"
        style={{
          display: loading ? "none" : "block",
          width: "100%",
        }}
      />
    </div>
  );
};

export default HeicViewer;
